var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertImage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 638.325,
    height: 688.882,
    viewBox: "0 0 638.325 688.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23613",
    "data-name": "Path 23613",
    d: "M0,0H29.579V22.184H0Z",
    fill: "rgba(0,0,0,0.7)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14563",
    "data-name": "Group 14563",
    transform: "translate(-1043 -4086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14208",
    "data-name": "Group 14208",
    transform: "translate(1043 4203.914)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3201",
    "data-name": "Ellipse 3201",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3091",
    "data-name": "Ellipse 3091",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3210",
    "data-name": "Ellipse 3210",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3100",
    "data-name": "Ellipse 3100",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3212",
    "data-name": "Ellipse 3212",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3102",
    "data-name": "Ellipse 3102",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3217",
    "data-name": "Ellipse 3217",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3106",
    "data-name": "Ellipse 3106",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3226",
    "data-name": "Ellipse 3226",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3112",
    "data-name": "Ellipse 3112",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3228",
    "data-name": "Ellipse 3228",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3113",
    "data-name": "Ellipse 3113",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3117",
    "data-name": "Ellipse 3117",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3118",
    "data-name": "Ellipse 3118",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3119",
    "data-name": "Ellipse 3119",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3120",
    "data-name": "Ellipse 3120",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3125",
    "data-name": "Ellipse 3125",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2800",
    "data-name": "Ellipse 2800",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3126",
    "data-name": "Ellipse 3126",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3132",
    "data-name": "Ellipse 3132",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2802",
    "data-name": "Ellipse 2802",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3133",
    "data-name": "Ellipse 3133",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3134",
    "data-name": "Ellipse 3134",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136",
    "data-name": "Ellipse 3136",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2804",
    "data-name": "Ellipse 2804",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137",
    "data-name": "Ellipse 3137",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139",
    "data-name": "Ellipse 3139",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2806",
    "data-name": "Ellipse 2806",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3143",
    "data-name": "Ellipse 3143",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144",
    "data-name": "Ellipse 3144",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3145",
    "data-name": "Ellipse 3145",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3146",
    "data-name": "Ellipse 3146",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3147",
    "data-name": "Ellipse 3147",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3151",
    "data-name": "Ellipse 3151",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2809",
    "data-name": "Ellipse 2809",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3152",
    "data-name": "Ellipse 3152",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3158",
    "data-name": "Ellipse 3158",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2811",
    "data-name": "Ellipse 2811",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3159",
    "data-name": "Ellipse 3159",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3160",
    "data-name": "Ellipse 3160",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3162",
    "data-name": "Ellipse 3162",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2813",
    "data-name": "Ellipse 2813",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3163",
    "data-name": "Ellipse 3163",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3165",
    "data-name": "Ellipse 3165",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815",
    "data-name": "Ellipse 2815",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3169",
    "data-name": "Ellipse 3169",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3178",
    "data-name": "Ellipse 3178",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3180",
    "data-name": "Ellipse 3180",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3185",
    "data-name": "Ellipse 3185",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3233",
    "data-name": "Ellipse 3233",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3194",
    "data-name": "Ellipse 3194",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3242",
    "data-name": "Ellipse 3242",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3196",
    "data-name": "Ellipse 3196",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3244",
    "data-name": "Ellipse 3244",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14232",
    "data-name": "Group 14232",
    transform: "translate(1563.411 4527.676) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957-2",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3198-2",
    "data-name": "Ellipse 3198",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958-2",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959-2",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3200-2",
    "data-name": "Ellipse 3200",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960-2",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3201-2",
    "data-name": "Ellipse 3201",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833-2",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3088-2",
    "data-name": "Ellipse 3088",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834-2",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835-2",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3090-2",
    "data-name": "Ellipse 3090",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836-2",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3091-2",
    "data-name": "Ellipse 3091",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961-2",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3202-2",
    "data-name": "Ellipse 3202",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2962-2",
    "data-name": "Ellipse 2962",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963-2",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3204-2",
    "data-name": "Ellipse 3204",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964-2",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837-2",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3092-2",
    "data-name": "Ellipse 3092",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838-2",
    "data-name": "Ellipse 2838",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839-2",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094-2",
    "data-name": "Ellipse 3094",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840-2",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965-2",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3206-2",
    "data-name": "Ellipse 3206",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2966-2",
    "data-name": "Ellipse 2966",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967-2",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3208-2",
    "data-name": "Ellipse 3208",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968-2",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841-2",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096-2",
    "data-name": "Ellipse 3096",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2842-2",
    "data-name": "Ellipse 2842",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843-2",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3098-2",
    "data-name": "Ellipse 3098",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844-2",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969-2",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3210-2",
    "data-name": "Ellipse 3210",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2970-2",
    "data-name": "Ellipse 2970",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845-2",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3100-2",
    "data-name": "Ellipse 3100",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2846-2",
    "data-name": "Ellipse 2846",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971-2",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3212-2",
    "data-name": "Ellipse 3212",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2972-2",
    "data-name": "Ellipse 2972",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847-2",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3102-2",
    "data-name": "Ellipse 3102",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2848-2",
    "data-name": "Ellipse 2848",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973-2",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3214-2",
    "data-name": "Ellipse 3214",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974-2",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975-2",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3216-2",
    "data-name": "Ellipse 3216",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976-2",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3217-2",
    "data-name": "Ellipse 3217",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849-2",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3104-2",
    "data-name": "Ellipse 3104",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850-2",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851-2",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3105-2",
    "data-name": "Ellipse 3105",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852-2",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3106-2",
    "data-name": "Ellipse 3106",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977-2",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3218-2",
    "data-name": "Ellipse 3218",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2978-2",
    "data-name": "Ellipse 2978",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979-2",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3220-2",
    "data-name": "Ellipse 3220",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980-2",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853-2",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3107-2",
    "data-name": "Ellipse 3107",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2854-2",
    "data-name": "Ellipse 2854",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855-2",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3108-2",
    "data-name": "Ellipse 3108",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856-2",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981-2",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3222-2",
    "data-name": "Ellipse 3222",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2982-2",
    "data-name": "Ellipse 2982",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983-2",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3224-2",
    "data-name": "Ellipse 3224",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984-2",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857-2",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3110-2",
    "data-name": "Ellipse 3110",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2858-2",
    "data-name": "Ellipse 2858",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859-2",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3111-2",
    "data-name": "Ellipse 3111",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860-2",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985-2",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3226-2",
    "data-name": "Ellipse 3226",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2986-2",
    "data-name": "Ellipse 2986",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861-2",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3112-2",
    "data-name": "Ellipse 3112",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2862-2",
    "data-name": "Ellipse 2862",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987-2",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3228-2",
    "data-name": "Ellipse 3228",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2988-2",
    "data-name": "Ellipse 2988",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863-2",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3113-2",
    "data-name": "Ellipse 3113",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2864-2",
    "data-name": "Ellipse 2864",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925-2",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3114-2",
    "data-name": "Ellipse 3114",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926-2",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927-2",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3116-2",
    "data-name": "Ellipse 3116",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928-2",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3117-2",
    "data-name": "Ellipse 3117",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865-2",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3118-2",
    "data-name": "Ellipse 3118",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798-2",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866-2",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3119-2",
    "data-name": "Ellipse 3119",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799-2",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3120-2",
    "data-name": "Ellipse 3120",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929-2",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3121-2",
    "data-name": "Ellipse 3121",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2930-2",
    "data-name": "Ellipse 2930",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931-2",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3123-2",
    "data-name": "Ellipse 3123",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932-2",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867-2",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3125-2",
    "data-name": "Ellipse 3125",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2800-2",
    "data-name": "Ellipse 2800",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868-2",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3126-2",
    "data-name": "Ellipse 3126",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801-2",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933-2",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3128-2",
    "data-name": "Ellipse 3128",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2934-2",
    "data-name": "Ellipse 2934",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935-2",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3130-2",
    "data-name": "Ellipse 3130",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936-2",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869-2",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3132-2",
    "data-name": "Ellipse 3132",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2802-2",
    "data-name": "Ellipse 2802",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870-2",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3133-2",
    "data-name": "Ellipse 3133",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803-2",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937-2",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3134-2",
    "data-name": "Ellipse 3134",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2938-2",
    "data-name": "Ellipse 2938",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871-2",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3136-2",
    "data-name": "Ellipse 3136",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2804-2",
    "data-name": "Ellipse 2804",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939-2",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3137-2",
    "data-name": "Ellipse 3137",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2940-2",
    "data-name": "Ellipse 2940",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805-2",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3139-2",
    "data-name": "Ellipse 3139",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2806-2",
    "data-name": "Ellipse 2806",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941-2",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3140-2",
    "data-name": "Ellipse 3140",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942-2",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943-2",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3142-2",
    "data-name": "Ellipse 3142",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944-2",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3143-2",
    "data-name": "Ellipse 3143",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872-2",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3144-2",
    "data-name": "Ellipse 3144",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807-2",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873-2",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3145-2",
    "data-name": "Ellipse 3145",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808-2",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3146-2",
    "data-name": "Ellipse 3146",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2946-2",
    "data-name": "Ellipse 2946",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947-2",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3149-2",
    "data-name": "Ellipse 3149",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948-2",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874-2",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3151-2",
    "data-name": "Ellipse 3151",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2809-2",
    "data-name": "Ellipse 2809",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875-2",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3152-2",
    "data-name": "Ellipse 3152",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810-2",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949-2",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154-2",
    "data-name": "Ellipse 3154",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2950-2",
    "data-name": "Ellipse 2950",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951-2",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3156-2",
    "data-name": "Ellipse 3156",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952-2",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876-2",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3158-2",
    "data-name": "Ellipse 3158",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2811-2",
    "data-name": "Ellipse 2811",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877-2",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3159-2",
    "data-name": "Ellipse 3159",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812-2",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953-2",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3160-2",
    "data-name": "Ellipse 3160",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2954-2",
    "data-name": "Ellipse 2954",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878-2",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3162-2",
    "data-name": "Ellipse 3162",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2813-2",
    "data-name": "Ellipse 2813",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955-2",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3163-2",
    "data-name": "Ellipse 3163",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2956-2",
    "data-name": "Ellipse 2956",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814-2",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3165-2",
    "data-name": "Ellipse 3165",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2815-2",
    "data-name": "Ellipse 2815",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879-2",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3166-2",
    "data-name": "Ellipse 3166",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880-2",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881-2",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3168-2",
    "data-name": "Ellipse 3168",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882-2",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3169-2",
    "data-name": "Ellipse 3169",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885-2",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3170-2",
    "data-name": "Ellipse 3170",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2886-2",
    "data-name": "Ellipse 2886",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887-2",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3172-2",
    "data-name": "Ellipse 3172",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888-2",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891-2",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3174-2",
    "data-name": "Ellipse 3174",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2892-2",
    "data-name": "Ellipse 2892",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893-2",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3176-2",
    "data-name": "Ellipse 3176",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894-2",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897-2",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3178-2",
    "data-name": "Ellipse 3178",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2898-2",
    "data-name": "Ellipse 2898",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900-2",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3180-2",
    "data-name": "Ellipse 3180",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2901-2",
    "data-name": "Ellipse 2901",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902-2",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3182-2",
    "data-name": "Ellipse 3182",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903-2",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904-2",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3184-2",
    "data-name": "Ellipse 3184",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905-2",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3185-2",
    "data-name": "Ellipse 3185",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989-2",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3230-2",
    "data-name": "Ellipse 3230",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(191.758 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990-2",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991-2",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3232-2",
    "data-name": "Ellipse 3232",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992-2",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3233-2",
    "data-name": "Ellipse 3233",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(243.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908-2",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3186-2",
    "data-name": "Ellipse 3186",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2909-2",
    "data-name": "Ellipse 2909",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910-2",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3188-2",
    "data-name": "Ellipse 3188",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911-2",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993-2",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3234-2",
    "data-name": "Ellipse 3234",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(202.81 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2994-2",
    "data-name": "Ellipse 2994",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(127.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995-2",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3236-2",
    "data-name": "Ellipse 3236",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(170.575 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996-2",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914-2",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3190-2",
    "data-name": "Ellipse 3190",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2915-2",
    "data-name": "Ellipse 2915",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916-2",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3192-2",
    "data-name": "Ellipse 3192",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917-2",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997-2",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3238-2",
    "data-name": "Ellipse 3238",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(213.862 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2998-2",
    "data-name": "Ellipse 2998",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(138.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999-2",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3240-2",
    "data-name": "Ellipse 3240",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(181.627 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000-2",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920-2",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3194-2",
    "data-name": "Ellipse 3194",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2921-2",
    "data-name": "Ellipse 2921",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001-2",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3242-2",
    "data-name": "Ellipse 3242",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(223.993 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3002-2",
    "data-name": "Ellipse 3002",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(148.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2923-2",
    "data-name": "Ellipse 2923",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3196-2",
    "data-name": "Ellipse 3196",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2924-2",
    "data-name": "Ellipse 2924",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003-2",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3244-2",
    "data-name": "Ellipse 3244",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(234.045 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3004-2",
    "data-name": "Ellipse 3004",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(159.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14230",
    "data-name": "Group 14230",
    transform: "translate(8871 11923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3892",
    "data-name": "Rectangle 3892",
    transform: "translate(-7788 -7797)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 556,
    height: 608,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 555,
    height: 607,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3893",
    "data-name": "Rectangle 3893",
    width: 556,
    height: 68,
    transform: "translate(-7788 -7513)",
    fill: "#e4f2ea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3894",
    "data-name": "Rectangle 3894",
    width: 556,
    height: 63,
    transform: "translate(-7788 -7387)",
    fill: "#e4f2ea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3895",
    "data-name": "Rectangle 3895",
    width: 556,
    height: 63,
    transform: "translate(-7788 -7267)",
    fill: "#e4f2ea",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3896",
    "data-name": "Rectangle 3896",
    width: 496,
    height: 1,
    transform: "translate(-7758 -7629)",
    fill: "#dae2d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3897",
    "data-name": "Rectangle 3897",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7513)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3898",
    "data-name": "Rectangle 3898",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7446)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3899",
    "data-name": "Rectangle 3899",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7387)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3900",
    "data-name": "Rectangle 3900",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7325)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3901",
    "data-name": "Rectangle 3901",
    width: 556,
    height: 1,
    transform: "translate(-7788 -7267)",
    fill: "#d7dfe6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14228",
    "data-name": "Group 14228",
    transform: "translate(-7392.001 -7502)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Available:_5_000.00",
    "data-name": "Available: $ 5,000.00",
    transform: "translate(130.001 40)",
    fill: "#111",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -139.524,
    y: 0
  }, "Available: $"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.2em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "5,000.00")), /*#__PURE__*/React.createElement("text", {
    id: "_0.76_USD",
    "data-name": "0.76 USD",
    transform: "translate(94.001 17)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.68,
    y: 0
  }, "0.76 USD")), /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(103.378 2.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 26.623,
    height: 16.468,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 26.623,
    height: 2.122,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 4.075)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 8.149)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 14.345)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 26.623,
    height: 2.122,
    transform: "translate(0 12.223)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 13.724,
    height: 9.853,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.394 1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.3,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.52,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-79.342 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.158,207.077l-.221-.68-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-26.001 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M26.937,160.624l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.3,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42H83.52Z",
    transform: "translate(-79.342 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M26.937,114.85l-.221.68H26l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.661,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.882,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-132.682 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.245,207.077l-.221-.68-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42Z",
    transform: "translate(-186.024 -201.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.024,160.624l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -158.17)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.661,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-132.682 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.024,114.85l-.221.68h-.715l.578.42-.221.68.578-.42.578.42-.221-.68.578-.42h-.715Z",
    transform: "translate(-186.024 -114.85)",
    fill: "#f0f0f0"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "USD_SGD_0.761_Inverse_1.314_16_Oct_2022_09:17_PM_08:00_16_Oct_2022_0.003_SGD_0.3_",
    "data-name": "USD/SGD 0.761 (Inverse 1.314) 16 Oct 2022 09:17 PM (+08:00) 16 Oct 2022  0.003 SGD (0.3%)",
    transform: "translate(-7262 -7412)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -235.328,
    y: 0
  }, "USD/SGD 0.761 (Inverse 1.314)"), /*#__PURE__*/React.createElement("tspan", {
    x: -236.4,
    y: 61
  }, "16 Oct 2022 09:17 PM (+08:00)"), /*#__PURE__*/React.createElement("tspan", {
    x: -93.744,
    y: 122
  }, "16 Oct 2022 "), /*#__PURE__*/React.createElement("tspan", {
    x: -138.736,
    y: 183
  }, "0.003 SGD (0.3%)")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14229",
    "data-name": "Group 14229",
    transform: "translate(-7394.001 -7572)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Available:_21_600.76",
    "data-name": "Available: $ 21,600.76",
    transform: "translate(132.001 40)",
    fill: "#111",
    fontSize: 14,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -142.31,
    y: 0
  }, "Available: $"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.2em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "21,600.76")), /*#__PURE__*/React.createElement("text", {
    id: "_1_SGD",
    "data-name": "1 SGD",
    transform: "translate(96.001 16)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.104,
    y: 0
  }, "1 SGD")), /*#__PURE__*/React.createElement("g", {
    id: "sg",
    transform: "translate(102.423 0.408)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23609",
    "data-name": "Path 23609",
    d: "M-20,0H13.276V22.184H-20Z",
    transform: "translate(19.076)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23610",
    "data-name": "Path 23610",
    d: "M-20,0H13.276V11.092H-20Z",
    transform: "translate(19.076)",
    fill: "#df0000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23611",
    "data-name": "Path 23611",
    d: "M41.988,37.04a3.9,3.9,0,0,0,.037,7.635,3.968,3.968,0,1,1-2.2-7.626,3.8,3.8,0,0,1,2.168-.009Z",
    transform: "translate(-35.24 -35.182)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23612",
    "data-name": "Path 23612",
    d: "M105.34,53.918l.226.693-.6-.425-.592.434.217-.7-.592-.43.735-.009.231-.693.231.693h.73Zm.809,2.4.231.7-.6-.425-.6.43.222-.7-.592-.434.735,0,.226-.7.231.693h.739Zm2.7-.018.226.7-.6-.43-.592.43.217-.7-.592-.43.735-.009.231-.693.231.693h.73Zm.8-2.385.226.7-.6-.425-.592.43.222-.7-.6-.434.739,0,.222-.7.231.693h.739Zm-2.14-1.585.231.7-.6-.43-.6.434.222-.7-.592-.434.73,0,.231-.7.231.693h.739Z",
    transform: "translate(-99.193 -48.834)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Your_conversion_has_been_created",
    "data-name": "Your conversion has been created",
    transform: "translate(-7502 -7689)",
    fill: "#111",
    fontSize: 24,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -204.78,
    y: 0
  }, "Your conversion has been created")), /*#__PURE__*/React.createElement("text", {
    id: "Conversion_ID:_C221111-7AFQLZ4",
    "data-name": "Conversion ID: C221111-7AFQLZ4",
    transform: "translate(-7502 -7654.596)",
    fill: "#777",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -124.624,
    y: 0
  }, "Conversion ID: "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#111",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, "C221111-7AFQLZ4")), /*#__PURE__*/React.createElement("g", {
    id: "Group_14231",
    "data-name": "Group 14231",
    transform: "translate(37.734 94.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14225",
    "data-name": "Group 14225",
    transform: "translate(-7561.735 -7861.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_023-label",
    "data-name": "023-label",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color",
    transform: "translate(1.328 1.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7667",
    "data-name": "Group 7667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M28.612,8.711,32.156,7.1a3.9,3.9,0,0,1,5.266,2.181l1.368,3.645a3.9,3.9,0,0,0,2.282,2.282l3.645,1.368A3.9,3.9,0,0,1,46.9,21.842l-1.611,3.544a3.9,3.9,0,0,0,0,3.227L46.9,32.156a3.9,3.9,0,0,1-2.181,5.266L41.072,38.79a3.9,3.9,0,0,0-2.282,2.282l-1.368,3.645A3.9,3.9,0,0,1,32.156,46.9l-3.544-1.611a3.9,3.9,0,0,0-3.227,0L21.842,46.9a3.9,3.9,0,0,1-5.266-2.181l-1.368-3.645a3.9,3.9,0,0,0-2.282-2.282L9.281,37.422A3.9,3.9,0,0,1,7.1,32.156l1.611-3.544a3.9,3.9,0,0,0,0-3.227L7.1,21.842a3.9,3.9,0,0,1,2.181-5.266l3.645-1.368a3.9,3.9,0,0,0,2.282-2.282l1.368-3.645A3.9,3.9,0,0,1,21.842,7.1l3.544,1.611A3.9,3.9,0,0,0,28.612,8.711Z",
    transform: "translate(-6.749 -6.749)",
    fill: "#00cf15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7671",
    "data-name": "Group 7671",
    transform: "translate(22.331 0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7668",
    "data-name": "Group 7668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M19.531,8.682a3.846,3.846,0,0,0,3.184,0L25.758,7.3a3.825,3.825,0,0,0-3.544-.2l-3.09,1.4Z",
    transform: "translate(-19.124 -6.753)",
    fill: "#00cf75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7670",
    "data-name": "Group 7670",
    transform: "translate(0.004 38.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M22.715,28.312a3.846,3.846,0,0,0-3.184,0l-.4.185,3.09,1.4a3.83,3.83,0,0,0,3.544-.2Z",
    transform: "translate(-19.126 -27.967)",
    fill: "#00cf75"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "line",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7676",
    "data-name": "Group 7676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M20.813,49.153a5.238,5.238,0,0,1-4.911-3.4l-1.367-3.64a2.553,2.553,0,0,0-1.493-1.493L9.4,39.254A5.243,5.243,0,0,1,6.47,32.172L8.08,28.633a2.554,2.554,0,0,0,0-2.109L6.472,22.985A5.246,5.246,0,0,1,9.4,15.9l3.641-1.365a2.552,2.552,0,0,0,1.491-1.491L15.9,9.4a5.246,5.246,0,0,1,7.083-2.931l3.539,1.609a2.561,2.561,0,0,0,2.109,0l3.541-1.609a5.243,5.243,0,0,1,7.082,2.933l1.367,3.64a2.55,2.55,0,0,0,1.491,1.493l3.64,1.365a5.243,5.243,0,0,1,2.933,7.082l-1.609,3.541a2.554,2.554,0,0,0,0,2.109l1.608,3.541a5.244,5.244,0,0,1-2.931,7.082l-3.642,1.365a2.547,2.547,0,0,0-1.491,1.491l-1.367,3.641a5.246,5.246,0,0,1-7.083,2.931l-3.539-1.609a2.554,2.554,0,0,0-2.109,0l-3.541,1.608a5.221,5.221,0,0,1-2.169.469Zm0-40.459a2.558,2.558,0,0,0-2.388,1.656L17.06,13.992a5.245,5.245,0,0,1-3.07,3.07l-3.64,1.363a2.55,2.55,0,0,0-1.426,3.442l1.609,3.539a5.24,5.24,0,0,1,0,4.341L8.925,33.287a2.549,2.549,0,0,0,1.426,3.44l3.64,1.365a5.236,5.236,0,0,1,3.07,3.07l1.367,3.64a2.549,2.549,0,0,0,3.44,1.426l3.541-1.609a5.242,5.242,0,0,1,4.339,0l3.541,1.609A2.55,2.55,0,0,0,36.73,44.8L38.1,41.16a5.245,5.245,0,0,1,3.07-3.07l3.641-1.365a2.549,2.549,0,0,0,1.426-3.44l-1.609-3.541a5.24,5.24,0,0,1,0-4.341l1.609-3.541a2.55,2.55,0,0,0-1.426-3.442l-3.64-1.365a5.245,5.245,0,0,1-3.07-3.07l-1.367-3.64a2.549,2.549,0,0,0-3.44-1.426L29.751,10.53a5.249,5.249,0,0,1-4.339,0L21.871,8.921a2.6,2.6,0,0,0-1.056-.227Z",
    transform: "translate(-6.001 -6.004)",
    fill: "#009e15"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M4.6,14.486l-4.4-4.4a.678.678,0,0,1,0-.958l.958-.958a.678.678,0,0,1,.958,0l2.967,2.967,6.356-6.356a.678.678,0,0,1,.958,0l.958.958a.678.678,0,0,1,0,.958L5.562,14.486A.678.678,0,0,1,4.6,14.486Z",
    transform: "translate(15.189 11.945)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "From_currency",
    "data-name": "From currency",
    transform: "translate(-7759 -7544)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "From currency")), /*#__PURE__*/React.createElement("text", {
    id: "To_currency",
    "data-name": "To currency",
    transform: "translate(-7759 -7474)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "To currency")), /*#__PURE__*/React.createElement("text", {
    id: "Exchange_rate_Settlement_date_Delivery_date_PayStreet_fee",
    "data-name": "Exchange rate Settlement date Delivery date PayStreet fee",
    transform: "translate(-7759 -7411)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Exchange rate"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 61
  }, "Settlement date"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 122
  }, "Delivery date"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183
  }, "PayStreet fee")), /*#__PURE__*/React.createElement("text", {
    id: "Conversion_summary",
    "data-name": "Conversion summary",
    transform: "translate(-7759 -7590)",
    fill: "#176b41",
    fontSize: 24,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conversion summary"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertImage3);
export default __webpack_public_path__ + "static/media/convert-image-3.4e5d8e8b740e69fdfffef97a6701ada1.svg";
export { ForwardRef as ReactComponent };